import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import React from "react";
import { CMSearchResultCellFrame } from "../CMSearchResultCellFrame/CMSearchResultCellFrame";
import {
  Box,
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";

export type CMSearchResultCellTextListProps = {
  value?: string[];
} & ComponentStyleProps;

export const CMSearchResultCellTextList = ({
  value = [],

  sx,
  ...rest
}: CMSearchResultCellTextListProps) => {
  const styles = useMultiStyleConfig("CMSearchResultCellTextListStyles");

  return (
    <CMSearchResultCellFrame sx={{ ...styles.container, ...sx }} {...rest}>
      <Box sx={styles.wrap}>
        {value.map((v, idx) => (
          <Text key={idx} sx={styles.content}>
            {v}
          </Text>
        ))}
      </Box>
    </CMSearchResultCellFrame>
  );
};

export const CMSearchResultCellTextListStyles: ComponentMultiStyleConfig = {
  parts: ["container", "wrap", "content"],
  baseStyle: {
    container: {},
    wrap: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "flex-start",
    },
    content: {
      whiteSpace: "normal",
      overflowWrap: "anywhere",
    },
  },
};
